import { useState } from "react";
import { Input, InputBase, Combobox, useCombobox, Loader } from "@mantine/core";
import { FaCheck } from "react-icons/fa6";
import { BsCheck } from "react-icons/bs";

const Select = ({
  data,
  value,
  setValue,
  placeholder,
  disable = false,
  isLoading = false,
}) => {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const options = data.map((item) => (
    <Combobox.Option value={item.value} key={item.value}>
      <div className="flex items-center justify-between ">
        {item.label}
        {item.value === value && <FaCheck className="text-[#999999]" />}
      </div>
    </Combobox.Option>
  ));

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={(val) => {
        setValue(val);
        combobox.closeDropdown();
      }}
      position="bottom"
    >
      <Combobox.Target>
        <InputBase
          component="button"
          type="button"
          pointer
          disabled={disable}
          rightSection={isLoading ? <Loader size={18} /> : <Combobox.Chevron />}
          rightSectionPointerEvents="none"
          onClick={() => combobox.toggleDropdown()}
          className="md:min-w-[230px] w-full"
        >
          <div className="w-full truncate font-light">
            {data.find((d) => d.value === value)?.label || (
              <Input.Placeholder>{placeholder}</Input.Placeholder>
            )}
          </div>
        </InputBase>
      </Combobox.Target>

      <Combobox.Dropdown className="max-h-[200px] overflow-auto z-50 relative">
        {isLoading ? (
          <Combobox.Empty>Loading....</Combobox.Empty>
        ) : data.length === 0 ? (
          <Combobox.Empty>No Data</Combobox.Empty>
        ) : (
          options
        )}
      </Combobox.Dropdown>
    </Combobox>
  );
};

export default Select;
